import { FC, useEffect, useState } from "react";
import { useAppSelector } from "../../app/hooks";
import TypingIndicator from "./TypingIndicator";

interface IProps {
    chats?: Array<{
        senderId: string;
        senderName: string;
        message: string;
        messageTime: Date;
        minMessageTime: boolean;
        messageType: string;
        roomOwner: boolean;
        isSent: boolean;
        handledByAgent?: string;
        messageFiles: string[];
        duration?: number;
    }>;
}

const MessageBody: FC<IProps> = () => {
    const { activeRoom, status } = useAppSelector((state) => state.chat);
    const [isTyping, setIsTyping] = useState(false);
    useEffect(() => {
        if (
            status.status == "TYPING" &&
            activeRoom.sessionId == status.sessionId &&
            status.userName == activeRoom.account
        ) {
            setIsTyping(true);
            const timeout = setTimeout(() => {
                setIsTyping(false);
            }, 500);
            return () => clearTimeout(timeout);
        } else if (
            status.status == "SENT" &&
            activeRoom.sessionId == status.sessionId
        ) {
            setIsTyping(false);
        }
    }, [activeRoom, status]);
    return (
        <>
            <div className="message-body">
                <div className="media-list">
                    <TypingIndicator isTyping={isTyping} />
                </div>
            </div>
        </>
    );
};

export default MessageBody;
